import authInitializer from 'src/modules/auth/authInitializer';

const initializers = [authInitializer];
export default initializers;
